/**
 * Product Accordion - 商品詳細ページ用アコーディオン
 * - 商品説明欄に書かれた <div class="product-accordion"> を検出して動作
 * - 複数のアコーディオンが同居しても各々独立して動作
 */
(function () {
  'use strict';

  function initAccordion(root) {
    const triggers = root.querySelectorAll('[data-accordion-trigger]');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const item = trigger.closest('[data-accordion-item]');
        const content = item.querySelector('[data-accordion-content]');
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          content.style.maxHeight = '0px';
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // 開いた状態でウィンドウリサイズされたとき高さを再計算
    window.addEventListener('resize', function () {
      root.querySelectorAll('[data-accordion-trigger][aria-expanded="true"]').forEach(function (t) {
        const c = t.closest('[data-accordion-item]').querySelector('[data-accordion-content]');
        c.style.maxHeight = c.scrollHeight + 'px';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-accordion').forEach(initAccordion);
  });
})();